export default __webpack_public_path__ + "static/media/logo-footer.86fc8541.png";